// Wait for all resources to be loaded, including global.js
window.addEventListener('load', function () {
  initializeAccordions();
});

function initializeAccordions() {
  // Target all accordions, both in collapsible-content sections and standalone
  const accordions = document.querySelectorAll('.accordion details');

  accordions.forEach((details) => {
    const summary = details.querySelector('summary');
    const content = details.querySelector('.accordion__content');

    // Remove any existing click handlers to prevent conflicts
    const newSummary = summary.cloneNode(true);
    summary.parentNode.replaceChild(newSummary, summary);

    newSummary.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation(); // Prevent event bubbling to other handlers

      // Find the parent collapsible content section to limit scope
      const parentSection = details.closest('.collapsible-content');

      if (details.open) {
        content.style.maxHeight = content.scrollHeight + 5 + 'px';
        void content.offsetHeight;
        content.style.maxHeight = '0px';
        content.style.paddingTop = '0';
        content.style.paddingBottom = '0';
        content.style.marginBottom = '0';
        setTimeout(() => {
          details.open = false;
        }, 400);
        return;
      }

      // Close other accordions only within the same section
      let otherAccordions;
      if (parentSection) {
        // If within collapsible-content, only close accordions in that section
        otherAccordions = parentSection.querySelectorAll('.accordion details');
      } else {
        // If standalone accordion, close all other standalone accordions
        otherAccordions = document.querySelectorAll('.accordion details:not(.collapsible-content .accordion details)');
      }

      otherAccordions.forEach((other) => {
        if (other !== details && other.open) {
          const otherContent = other.querySelector('.accordion__content');
          otherContent.style.maxHeight = otherContent.scrollHeight + 5 + 'px';
          void otherContent.offsetHeight;
          otherContent.style.maxHeight = '0px';
          otherContent.style.paddingTop = '0';
          otherContent.style.paddingBottom = '0';
          otherContent.style.marginBottom = '0';
          setTimeout(() => {
            other.open = false;
          }, 400);
        }
      });

      details.open = true;
      content.style.maxHeight = '0px';
      content.style.paddingTop = '1rem';
      content.style.paddingBottom = '1rem';
      content.style.marginBottom = '1.5rem';
      requestAnimationFrame(() => {
        content.style.maxHeight = content.scrollHeight + 5 + 'px';
      });
    });
  });
}
